export default __webpack_public_path__ + "static/media/confirm-email-page-logo.9fcec908.png";